 (function() {
  'use strict';
  angular.module('benefits')
  .controller('benefitsLookupController', ['$scope', '$uibModal', 'Members', '$filter', 'benefitService', 'taxIdBlockService','$log','$state', '$q', '$window', '$http',
    '$translate', '$rootScope', 'secSecurityService',
    function($scope, $uibModal,Members,$filter,benefitService, taxIdBlockService, $log, $state, $q, $window, $translate, $rootScope, $http, secSecurityService) {
    var vm = this;
    vm.minDate = '01/01/1900';
    vm.today   =  $filter('date')(new Date(),'MM/dd/yyyy');
    vm.reset = reset;
    vm.validate = validate;
    vm.running = false;
    vm.submit = submit;
    vm.initMembers = initMembers;
    vm.model = {};
    vm.model.dhmo = false;
    vm.applicationName = $rootScope.applicationName;
    
    initMembers();
    initOptions();

    function initMembers(){
      vm.model.members = {};
      vm.model.referenceId = "";
      vm.validateDisabled = false;
      vm.memberNotFound = false;
    }

    function initOptions(){
      vm.optgroups = undefined;
      vm.options  = undefined;
    }

    function reset(){
      $scope.errorControl.hideErrors();
      vm.model={};      
      initMembers();
      initOptions();
      $($window).scrollTop(0);
      $window.document.getElementById('subscriberId').focus();
    }


    function submit(){
      if ($scope.benefitsLookupForm.$valid) {
        let params = _.merge({referenceId:vm.model.referenceId}, lookupParams(vm.model));
        $state.go('benefits.dashboard', params);
        $($window).scrollTop(0);
      }
    }

    function lookupParams(data) {
      let lookupParams = _.pick(vm.model,["subscriberId","dateOfBirth"]);
      lookupParams.subscriberId = $filter('subscriberId')(lookupParams.subscriberId);
      lookupParams.dateOfBirth = $filter('teledentDate')(lookupParams.dateOfBirth);
      return lookupParams;
    }

    function validate() {
      $scope.errorControl.showErrors();
      initMembers();
      initOptions();
      $($window).scrollTop($window.document.getElementById('scrollTo').offsetTop);

      if ($scope.benefitsLookupForm.$valid) {
        vm.running = true;
        vm.serviceUnavailable = false;
        vm.model.noPolicy = false;
        Members.query(lookupParams(vm.model), (res) => {
          let data = res.data;
            vm.model.members = _.filter(data,(d) => {return d.subscriberId !== undefined;});
            vm.model.members = taxIdBlockService.filterMembers(vm.model.members);
            if(vm.model.members.length > 0 && vm.model.members[0].invalidMember) {
              vm.subscriberIdBlock = true;
              vm.subscriberIdBlockMessage = vm.model.members[0].supportString;
              vm.running = false;
            } else{
              if (vm.model.members.length > 0) {
                buildSelectOptions();
                vm.model.referenceId = (vm.options || vm.optgroups || vm.model.members[0].policies.length === 0) ? "" : vm.model.members[0].policies[0].referenceId;
                if (vm.model.members.length === 1 && vm.model.members[0].policies.length === 0) {
                  vm.model.noPolicy = true;
                }
              } else if (res.serviceUnavailable) {
                vm.serviceUnavailable = true;
              } else {
                vm.memberNotFound = true;
              }
              vm.running = false;
              vm.validateDisabled = true;
            }
        },(error) => {
          vm.running= false;
        });
      }
    }

   
    function buildSelectOptions(){
      let memberNames = [];
      let groupNumbers = [];
      let multiMembersMultiPolicies = hasMultiMembersMultiPolicies();
      vm.optgroups = multiMembersMultiPolicies ? [] : undefined;
      _.each(vm.model.members,(member,index) => {
        if (multiMembersMultiPolicies){
            vm.optgroups[index] = {};
            vm.optgroups[index].label =  member.firstName + ' ' + member.lastName;
            vm.optgroups[index].options = [];
            addOptions(vm.optgroups[index].options,member.policies);
        }else{
            addOptions(groupNumbers,member.policies);
            addOptions(memberNames,member.policies,member.firstName + ' ' + member.lastName);
        }
      });
      if (groupNumbers.length > 1 || memberNames.length > 1) {
        vm.options = {};
        vm.options.groups = groupNumbers && groupNumbers.length > 1 ? groupNumbers : undefined;
        vm.options.members = memberNames && memberNames.length > 1 ? memberNames : undefined;
      }
    }

    function hasMultiMembersMultiPolicies(){
      let multiMembersMultiPolicies = false;
      if (vm.model.members.length > 1) {
        let policies = [];
        _.each(vm.model.members,(member) => {
          if (member.policies.length > 1){
              multiMembersMultiPolicies = true;
          }else{
              if (!_.find(policies,(p) => {return p===member.policies[0].groupNumber;})) {
                  policies.push(member.policies[0].groupNumber);
                  if (policies.length > 1) {multiMembersMultiPolicies = true;}
              }
          }
        });
      }
      return multiMembersMultiPolicies;
    }

    $scope.$watch(() => vm.model.referenceId, function(refId) {
      vm.model.active = undefined;
      vm.model.secured = undefined;
      vm.model.dhmoContactInfo = undefined;
      _.each(vm.model.members, (member) => {
        let policy = _.find(member.policies, (p) => p.referenceId === refId );
        if (policy) {
          vm.model.active = policy.status === 'Active';
          vm.model.secured = policy.secured
          vm.model.cancelDate = policy.cancelDate;
          if (benefitService.hasDentalHmoPolicy(policy)) {
            vm.model.dhmo = false;
            secSecurityService.getDhmoStatus().then(function(hasDhmo) {
              if (!hasDhmo) {
                vm.model.dhmo = true;
                vm.modalOpen = true;
                var modalInstance = $uibModal.open({
                  templateUrl: '/js/benefits/dhmoModal.html' + appVersion,
                  controllerAs:'vm',
                  controller: 'dhmoModalController',
                  size: 'lg',
                  animation: false,
                  resolve:{
                    policy: function() {
                      return policy;
                    },
                    member: function() {
                      return member;
                    }
                  }
                });
                modalInstance.result.then(function(data) {
                  vm.modalOpen = false;
                  vm.validateDisabled = false;
                }, function() {
                  vm.modalOpen = false;
                  vm.validateDisabled = false;
                });
              } else {
                vm.modalOpen = false;
              }
            });
          } else {
            vm.model.dhmo = false;
          }
        }
      });
    });

    function addOptions(options, subscriberData, subscriberName){
        _.each(subscriberData,(data) => {
          let optionName = subscriberName ? subscriberName : (data.secured ? "Policy in secured group" : data.groupNumber + " - " + data.policyType);
          if (!_.find(options,(o) => {return o.name === optionName;})){
              let option = {};
              option.name  = optionName;
              option.value = data.referenceId;
              option.disabled = !!data.secured;
              options.push(option);
          }
       });
    }
  }]);
})();
